app.controller('CIF-CTRL', ['$scope', '$window', '$rootScope', '$uibModal', '$q', 'deviceDetector', '$filter', '$http', '$timeout',
    function ($scope, $window, $rootScope, $uibModal, $q, deviceDetector, $filter, $http, $timeout) {

    //Setting Camera
    $scope.device = deviceDetector;
    $scope.isMobile = $scope.device.isMobile();

    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];

    $scope.filenameFotoDiri = "";
    $scope.fileFotoDiri = "";
    $scope.fileFotoDiriext = "";
    $scope.fotodiriFile = [];

    $scope.filenameTandaTangan = "";
    $scope.fileTandaTangan = "";
    $scope.fileTandaTanganext = "";
    $scope.tandatanganFile = [];
    //$scope.ktpPhoto = "";

    $scope.openCamera = function (tipe) {
        let message = tipe;
        let url = 'ModalCamera.html';
        let ctrl = 'CameraController';


        if ($scope.device.isMobile()) {
            //url = 'ModalBrowse.html';
            //ctrl = 'BrowseController';
            //$scope.append = 'data:image/png;base64,';
        }

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return message;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            //console.log('ktp',resolvedResponse);
            if (resolvedResponse) {
                if (tipe == "KTP"){
                    $scope.ktpPhoto = resolvedResponse;

                    Swal.fire({
                        title: "Checking KTP...",
                        //text: "Please wait",
                        html: `Please wait <i class="far fa-xs fa-spin fa-redo-alt"></i>`,
                        icon: "info",
                        showConfirmButton: false,
                        showCancelButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            if ($scope.CIFInvestor.QuestionRDN == 3) {
                                return $http({
                                    method: 'POST',
                                    url: '/service/client.svc/OCRBukopin?CIFNID=' + $scope.CIFInvestor.NID,
                                    data: {
                                        KTPImage: $scope.ktpPhoto  // Replace with actual base64 image string
                                    }
                                }).then(function (response) {
                                    console.log("OCRChecking", response);
                                    $scope.GetCIF();
                                    Swal.close();

                                    //$window.location.href = "#/cif/data-pernyataan";
                                }, function (error) {
                                    console.log("Error in OCRChecking:", error);
                                    Swal.close(); // Close the Swal in case of an error too
                                });
                            } else {
                                Swal.close();
                                //$window.location.href = "#/cif/data-pernyataan";
                            }
                        }
                    })
                }
                else if (tipe == "NPWP")
                    $scope.npwpPhoto = resolvedResponse;
                else if (tipe == "SELFIE")
                    $scope.selfiePhoto = resolvedResponse;
                else if (tipe == "OTHERS")
                    $scope.othersPhoto = resolvedResponse;
                else if (tipe == "PARENT")
                    $scope.parentPhoto = resolvedResponse;
                else
                    $scope.ttdPhoto = resolvedResponse;
            }
        }, function () { });
    };

    $scope.remove = function (tipe) {
        if (tipe == "KTP")
            $scope.ktpPhoto = '';
        else if (tipe == "SELFIE")
            $scope.selfiePhoto = '';
        else if (tipe == "NPWP")
            $scope.npwpPhoto = '';
        else if (tipe == "OTHERS")
            $scope.othersPhoto = '';
        else if (tipe == "PARENT")
            $scope.parentPhoto = '';
        else
            $scope.ttdPhoto = '';
    };

    $scope.selectKTP = function (files) {

        $scope.KTPFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {

            if (allowed)
                $scope.fileKTP = btoa(e.target.result.toString());
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

        if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {

            allowed = false;
            $scope.fileKTPext = '';
            $scope.KTPFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        } else {

            $scope.filenameKTP = files[0].name;
        }
    };

    $scope.selectFotoDiri = function (files) {

        $scope.fotodiriFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {

            if (allowed)
                $scope.fileFotoDiri = btoa(e.target.result.toString());
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileFotoDiriext = files[0].name.substr(files[0].name.lastIndexOf('.'));

        if ($scope.allowedExt.indexOf($scope.fileFotoDiriext.toLowerCase()) < 0) {

            allowed = false;
            $scope.fileFotoDiriext = '';
            $scope.fotodiriFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        } else {

            $scope.filenameFotoDiri = files[0].name;
        }
    };

    $scope.selectTandaTangan = function (files) {

        $scope.tandatanganFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {

            if (allowed)
                $scope.fileTandaTangan = btoa(e.target.result.toString());
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileTandaTanganext = files[0].name.substr(files[0].name.lastIndexOf('.'));
        if ($scope.allowedExt.indexOf($scope.fileTandaTanganext.toLowerCase()) < 0) {

            allowed = false;
            $scope.fileTandaTanganext = '';
            $scope.tandatanganFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        } else {

            $scope.filenameTandaTangan = files[0].name;
        }
    };

    $scope.clickRemoveKTP = function (file, event, key) {

        event.preventDefault();
        $scope.fileKTP = "";
        $scope.filenameKTP = "";
        $scope.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };

    $scope.clickRemoveFotoDiri = function (file, event, key) {

        event.preventDefault();
        $scope.fileFotoDiri = "";
        $scope.filenameFotoDiri = "";
        $scope.fileFotoDiriext = "x";
        $scope.fotodiriFile.splice(key, 1);
        $scope.fotodiriFile = [];

        return null;
    };

    $scope.clickRemoveTandaTangan = function (file, event, key) {

        event.preventDefault();
        $scope.fileTandaTangan = "";
        $scope.filenameTandaTangan = "";
        $scope.fileTandaTanganext = "x";
        $scope.tandatanganFile.splice(key, 1);
        $scope.tandatanganFile = [];
        return null;
    };

    $scope.resetSign = function () {

        $scope.finishSignature = false;
        $scope.clear();
    };

    $scope.completeSign = function () {

        $scope.signature = $scope.accept();

        if ($scope.signature.dataUrl && !$scope.signature.isEmpty) {

            $scope.finishSignature = true;
            $scope.CIFInvestor.TandaTanganFile = $scope.signature.dataUrl.substr($scope.signature.dataUrl.lastIndexOf(',') + 1);

        } else {

            $scope.finishSignature = false;
        }
    };
    //end setting camera

    $scope.CIFInvestor = {
        Sex: '',
        Religion: '',
        MaritalStatus: '',
        Education: '',
    }
    let tmpdate = new Date();
    $scope.PhoneCode = '+62';
    tmpdate.setFullYear(tmpdate.getFullYear() - 17);
    $scope.maxDate = tmpdate.toISOString().slice(0, 10);
    $scope.maxResidencyDate = new Date().toISOString().slice(0, 10);
    $scope.Kewarganegaraan = 'Warga Negara Indonesia (WNI)';
    $scope.KewarganegaraanOption = ['Warga Negara Indonesia (WNI)', 'Lainnya'];
    $scope.IDLength = 16;
    $scope.chkSeumurHidup = true;
    $scope.DisabledSeumurHidup = true;

    $scope.IDCardCitySelected = '';
    $scope.DomicileCitySelected = '';
    $scope.NationalitySelected = '';
    $scope.IDCardCountrySelected = '';
    $scope.IDCardKecamatanSelected = '';
    $scope.IDCardOK = true;

    $scope.ListNationality = [];
    $scope.ListLookup = [];
    $scope.ListReligion = [];
    $scope.ListMarital = [];
    $scope.ListEducation = [];
    $scope.ListKecamatan = [];
    $scope.ListKecamatanDomicile = [];
    $scope.ListKecamatanAll = [];
    $scope.ListKelurahan = [];
    $scope.ListKelurahanDomicile = [];

        //INFORMATION BO
    $scope.CompanyCityBOSelected = '';
    $scope.BOIDCardCitySelected = '';
    $scope.BODomicileCitySelected = '';
    $scope.BOIDCardKecamatanSelected = '';
    $scope.BOListKecamatan = [];
    $scope.BOListKelurahan = [];
    $scope.ListIncomeBO = [];
    $scope.selectedFundSourceBO = [];
    $scope.selectedSpouseFundSource = [];

    $scope.selectCity = function (item, model, label, event) {
        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.CompanyCityBO = item.CIFProvinceCityNID;
        }
    };


        //Start INFORMATION BO
    $scope.selectBOIDCardCity = function (item, model, label, event) {
        $scope.BOListKecamatan = '';
        $scope.BOListKelurahan = '';


        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.BOIDCardCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.BOListKecamatan = data.data.d;
                $scope.BOkecamatanChange();
            }, function (error) { });

        }
    };

        
    $scope.selectBODomicileCity = function (item, model, label, event) {
        $scope.BOListKecamatanDomicile = '';
        $scope.BOListKelurahanDomicile = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.BODomicileCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.BOListKecamatanDomicile = data.data.d;
                $scope.BOkecamatanDomicileChange();
            }, function (error) { });

        }
    };


    $scope.BOkecamatanChange = function () {
        if ($scope.CIFInvestor.BOIDCardKecamatan) {
            $scope.BOListKelurahan = $filter('filter')($scope.BOListKecamatan, { Kecamatan: $scope.CIFInvestor.BOIDCardKecamatan }, true);
        }
    }

    $scope.BOkelurahanChange = function () {
        if ($scope.CIFInvestor.BOIDCardKelurahan) {
            let temp = $filter('filter')($scope.BOListKecamatan, { Kelurahan: $scope.CIFInvestor.BOIDCardKelurahan }, true);
            if (temp) {
                $scope.CIFInvestor.IDCardPostalCode = temp[0].PostalCode;
            }
        }
    };

    $scope.BOkecamatanDomicileChange = function () {
        if ($scope.CIFInvestor.BODomicileKecamatan) {
            $scope.BOListKelurahanDomicile = $filter('filter')($scope.BOListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.BODomicileKecamatan }, true);
        }
    };

    $scope.BOkelurahanDomicileChange = function () {
        if ($scope.CIFInvestor.BODomicileKelurahan) {
            let temp = $filter('filter')($scope.BOListKecamatanDomicile, { Kelurahan: $scope.CIFInvestor.BODomicileKelurahan }, true);
            if (temp) {
                $scope.CIFInvestor.BODomicilePostalCode = temp[0].PostalCode;
            }
        }
    };

    $scope.CopyFromIDBO = function () {
        if ($scope.CIFInvestor.CopyIDBO) {
            $scope.CIFInvestor.BODomicilePostalCode = $scope.CIFInvestor.BOIDCardPostalCode;
            $scope.CIFInvestor.BODomicileAddress = $scope.CIFInvestor.BOIDCardAddress;
            $scope.CIFInvestor.BODomicileRT = $scope.CIFInvestor.BOIDCardRT;
            $scope.CIFInvestor.BODomicileRW = $scope.CIFInvestor.BOIDCardRW;
            $scope.CIFInvestor.BODomicileKelurahan = $scope.CIFInvestor.BOIDCardKelurahan;
            $scope.CIFInvestor.BODomicileKecamatan = $scope.CIFInvestor.BOIDCardKecamatan;
            $scope.CIFInvestor.BODomicileCity = $scope.CIFInvestor.BOIDCardCity;
            $scope.BODomicileCitySelected = $scope.BOIDCardCitySelected;
        }
        else {
            $scope.CIFInvestor.BODomicilePostalCode = '';
            $scope.CIFInvestor.BODomicileAddress = '';
            $scope.CIFInvestor.BODomicileRT = '';
            $scope.CIFInvestor.BODomicileRW = '';
            $scope.CIFInvestor.BODomicileKelurahan = '';
            $scope.CIFInvestor.BODomicileKecamatan = '';
            $scope.CIFInvestor.BODomicileCity = 0;
            $scope.BODomicileCitySelected = '';
        }

    };

    $scope.toggleFundSourceBOItem = function (fundsource) {
        let indexCIFLookupInteger = $scope.selectedFundSourceBO.indexOf(fundsource.CIFLookupInteger);

        if (indexCIFLookupInteger > -1)
            $scope.selectedFundSourceBO.splice(indexCIFLookupInteger, 1);
        else
            $scope.selectedFundSourceBO.push(fundsource.CIFLookupInteger);

        if ($scope.selectedFundSourceBO.indexOf(1) < 0)
            $scope.CIFInvestor.FundSourceTextBO = '';

    }
    //END INFORMATION BO


    $scope.checkIDCardNumber = function () {

        if ($scope.CIFInvestor.IDCardNumber) {
            $http({
                method: 'GET',
                url: '/service/client.svc/checkIDCardNumber?KTP=' + $scope.CIFInvestor.IDCardNumber,
                cache: false
            }).then(function (data) {
                if (data.data.d != null) {
                    var obj = data.data.d;
                    if (obj.key && obj.key == 1) {
                        $scope.CIFInvestor.IDCardNumber = '';
                        Swal.fire('Gagal', obj.value, "error");
                    }
                }
            }, function (error) { });
        }
    }

    $scope.KewarganegaraanChange = function () {

        if ($scope.Kewarganegaraan == 'Warga Negara Indonesia (WNI)') {
            $scope.IDLength = 16;
            $scope.chkSeumurHidup = true;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 102;
            $scope.CIFInvestor.NationalityBO = 102;
            $scope.CIFInvestor.IDCardCountry = 102;
            $scope.CIFInvestor.CopyID = true;
            $scope.CIFInvestor.CopyIDBO = true;
            $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
            $scope.CIFInvestor.IDCardExpireDateBO = new Date(9998, 11, 31);
        }
        else if ($scope.Kewarganegaraan == 'Lainnya') {
            $scope.IDLength = 8;
            $scope.chkSeumurHidup = false;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 0;
            $scope.CIFInvestor.NationalityBO = 0;
            $scope.CIFInvestor.IDCardCountry = 0;
            $scope.CIFInvestor.CopyID = false;
            $scope.CIFInvestor.CopyIDBO = true;
            $scope.CIFInvestor.IDCardExpireDate = '';
            $scope.CIFInvestor.IDCardExpireDateBO = '';
            $scope.CIFInvestor.IDCardCity = 0;
            $scope.CIFInvestor.IDCardKecamatan = '';
            $scope.CIFInvestor.IDCardKelurahan = '';
            $scope.CIFInvestor.IDCardRT = '';
            $scope.CIFInvestor.IDCardRW = '';
            $scope.CIFInvestor.IDCardAddress = '';
            $scope.CIFInvestor.BOIDCardCity = 0;
            $scope.CIFInvestor.BOIDCardKecamatan = '';
            $scope.CIFInvestor.BOIDCardKelurahan = '';
            $scope.CIFInvestor.BOIDCardRT = '';
            $scope.CIFInvestor.BOIDCardRW = '';
            $scope.CIFInvestor.BOIDCardAddress = '';
            $scope.IDCardCitySelected = '';
            $scope.BOIDCardCitySelected = '';
        }
    }

    $scope.regex = '^[a-zA-Z0-9._-]+$'

    $scope.KewarganegaraanChangeBO = function () {

        if ($scope.Kewarganegaraan == 'Warga Negara Indonesia (WNI)') {
            $scope.IDLength = 16;
            $scope.chkSeumurHidup = true;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 102;
            $scope.CIFInvestor.NationalityBO = 102;
            $scope.CIFInvestor.IDCardCountry = 102;
            $scope.CIFInvestor.CopyID = true;
            $scope.CIFInvestor.CopyIDBO = true;
            $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
            $scope.CIFInvestor.IDCardExpireDateBO = new Date(9998, 11, 31);
        }
        else if ($scope.Kewarganegaraan == 'Lainnya') {
            $scope.IDLength = 8;
            $scope.chkSeumurHidup = false;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 0;
            $scope.CIFInvestor.NationalityBO = 0;
            $scope.CIFInvestor.IDCardCountry = 0;
            $scope.CIFInvestor.CopyID = false;
            $scope.CIFInvestor.CopyIDBO = true;
            $scope.CIFInvestor.IDCardExpireDate = '';
            $scope.CIFInvestor.IDCardExpireDateBO = '';
            $scope.CIFInvestor.IDCardCity = 0;
            $scope.CIFInvestor.IDCardKecamatan = '';
            $scope.CIFInvestor.IDCardKelurahan = '';
            $scope.CIFInvestor.IDCardRT = '';
            $scope.CIFInvestor.IDCardRW = '';
            $scope.CIFInvestor.IDCardAddress = '';
            $scope.CIFInvestor.BOIDCardCity = 0;
            $scope.CIFInvestor.BOIDCardKecamatan = '';
            $scope.CIFInvestor.BOIDCardKelurahan = '';
            $scope.CIFInvestor.BOIDCardRT = '';
            $scope.CIFInvestor.BOIDCardRW = '';
            $scope.CIFInvestor.BOIDCardAddress = '';
            $scope.IDCardCitySelected = '';
            $scope.BOIDCardCitySelected = '';
        }
    }

    $scope.selectNationality = function (item, model, label, event) {
        if (item.CIFCountryNID) {

            $scope.CIFInvestor.Nationality = item.CIFCountryNID;
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
            $scope.NationalitySelected = item;
            $scope.IDCardCountrySelected = item;
        }
    };

    $scope.selectIDCardCountry = function (item, model, label, event) {
        if (item.CIFCountryNID) 
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
        
    };

    $scope.selectIDCardCity = function (item, model, label, event) {
        $scope.ListKecamatan = '';
        $scope.ListKelurahan = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.IDCardCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatan = data.data.d;
                $scope.kecamatanChange();
            }, function (error) { });

        }

    };

    $scope.selectDomicileCity = function (item, model, label, event) {
        $scope.ListKecamatanDomicile = '';
        $scope.ListKelurahanDomicile = '';

        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.DomicileCity = item.CIFProvinceCityNID;

            $http({
                method: 'GET',
                url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + item.CIFProvinceCityNID,
                cache: true,
            }).then(function (data) {
                $scope.ListKecamatanDomicile = data.data.d;
                $scope.kecamatanChange();
            }, function (error) { });

        }
    };

    $scope.kecamatanChange = function () {

        if ($scope.CIFInvestor.IDCardKecamatan) 
            $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
    }

    $scope.kelurahanChange = function () {

        if ($scope.CIFInvestor.IDCardKelurahan) {

            let temp = $filter('filter')($scope.ListKecamatan, { Kelurahan: $scope.CIFInvestor.IDCardKelurahan }, true);
            if (temp)
                $scope.CIFInvestor.IDCardPostalCode = temp[0].PostalCode;
            
        }
    }

    $scope.kecamatanDomicileChange = function () {
        if ($scope.CIFInvestor.DomicileKecamatan)
            $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
    }

    $scope.kelurahanDomicileChange = function () {
        if ($scope.CIFInvestor.DomicileKelurahan) {
            let temp = $filter('filter')($scope.ListKecamatanDomicile, { Kelurahan: $scope.CIFInvestor.DomicileKelurahan }, true);
            if (temp) 
                $scope.CIFInvestor.DomicilePostalCode = temp[0].PostalCode;
        }
    }

    $scope.CopyFromID = function () {
        if ($scope.CIFInvestor.CopyID) {

            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
        } else {

            $scope.CIFInvestor.DomicilePostalCode = '';
            $scope.CIFInvestor.DomicileAddress = '';
            $scope.CIFInvestor.DomicileRT = '';
            $scope.CIFInvestor.DomicileRW = '';
            $scope.CIFInvestor.DomicileKelurahan = '';
            $scope.CIFInvestor.DomicileKecamatan = '';
            $scope.CIFInvestor.DomicileCity = 0;
            $scope.DomicileCitySelected = '';
        }
    };

    $scope.mustSelect = function (event, field) {

        if (event.keyCode == 27) {

            let returnValue = true;
            switch (field) {

                case 'IDCard': $scope.CIFInvestor.IDCardCity = ''; returnValue = false;
                    break;
                case 'Domicile': $scope.CIFInvestor.DomicileCity = ''; returnValue = false;
                    break;
                case 'Correspondence': $scope.CIFInvestor.CorrespondenceCity = ''; returnValue = false;
                    break;
                default:
                    break;
            }
            return returnValue;
        }
        return true;
    }

    var allPromise = $q.all([
        $scope.retrieveSessions(),


         $http({
             method: 'GET',
             url: '/service/client.svc/GetCIFCountry',
             cache: true,
         }).then(function (data) {
             $scope.ListNationality = data.data.d;
         }, function (error) { }),

         $http({
             method: 'GET',
             url: '/service/client.svc/GetCIFCountryAll',
             cache: true,
         }).then(function (data) {
             $scope.ListCountry = data.data.d;
         }, function (error) { }),

         $http({
             method: 'GET',
             url: '/service/client.svc/GetCIFProvinceCity',
             cache: true,
         }).then(function (data) {
             $scope.ListProvinceCity = data.data.d;
         }, function (error) { }),

         $http({
               method: 'GET',
               url: '/service/client.svc/GetCIFLookup',
               cache: true,
           }).then(function (data) {
               $scope.ListLookup = data.data.d;
               if ($scope.ListLookup) {
                   $scope.ListReligion = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Religion' }, true);
                   $scope.ListMarital = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                   $scope.ListEducation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
                   $scope.ListIncomeBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
                   $scope.ListFundSourceBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'FundSource' }, true);
                   $scope.ListIncomePerAnnumBO = $filter('filter')($scope.ListLookup, { CIFLookupID: 'IncomePerAnnum' }, true);
               }
           }, function (error) { }),

    ]);

    $scope.GetCIF = function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {

            if (data.data.d.Email != null) {

                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 1;

                //info upload 
                $scope.filenameKTP = $scope.CIFInvestor.KTPFile;
                $scope.filenameFotoDiri = $scope.CIFInvestor.SelfieFile;
                $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
                if ($scope.filenameKTP && !$scope.ktpPhoto) {

                    if (!$scope.filenameKTP.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameKTP,
                            responseType: 'blob',

                        }).then(function (response) {
                            if (response.data) {
                                var reader = new FileReader();
                                reader.readAsDataURL(response.data);
                                reader.onloadend = function () {
                                    $scope.ktpPhoto = reader.result;
                                    $scope.showKTP = false; ''
                                }

                            }
                            //$scope.KTPFile = [];
                            //$scope.KTPFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                if ($scope.filenameFotoDiri) {

                    if (!$scope.filenameFotoDiri.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameFotoDiri,
                            responseType: 'blob',
                        }).then(function (response) {
                            if (response.data) {
                                var reader3 = new FileReader();
                                reader3.readAsDataURL(response.data);
                                reader3.onloadend = function () {
                                    $scope.selfiePhoto = reader3.result;
                                }

                            }
                            //$scope.fotodiriFile = [];
                            //$scope.fotodiriFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                if ($scope.filenameTandaTangan) {

                    if (!$scope.filenameTandaTangan.endsWith(".pdf")) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.filenameTandaTangan,
                            responseType: 'blob',

                        }).then(function (response) {
                            if (response.data) {
                                var reader4 = new FileReader();
                                reader4.readAsDataURL(response.data);
                                reader4.onloadend = function () {
                                    $scope.ttdPhoto = reader4.result;
                                }

                            }
                            //$scope.tandatanganFile = [];
                            //$scope.tandatanganFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    }
                };
                //end info upload


                if ($scope.CIFInvestor.Sex == 0)
                    $scope.CIFInvestor.Sex = '';

                if ($scope.CIFInvestor.BenefecialOwner == 0)
                    $scope.CIFInvestor.BenefecialOwner = '';

                if ($scope.CIFInvestor.Religion == 0)
                    $scope.CIFInvestor.Religion = '';

                if ($scope.CIFInvestor.MaritalStatus == 0)
                    $scope.CIFInvestor.MaritalStatus = '';

                if ($scope.CIFInvestor.Education == 0)
                    $scope.CIFInvestor.Education = '';

                if (data.data.d.BirthDate)
                    $scope.CIFInvestor.BirthDate = new Date(data.data.d.BirthDate);


                if (data.data.d.IDCardCity) {
                    $scope.IDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.IDCardCity }, true)[0];
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.IDCardCity,
                        cache: true,
                    }).then(function (dataKecamatan) {
                        $scope.ListKecamatan = dataKecamatan.data.d;
                        if ($scope.ListKecamatan)
                            $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
                    }, function (error) { });
                }

                if (data.data.d.DomicileCity) {
                    $scope.DomicileCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.DomicileCity }, true)[0];
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.DomicileCity,
                        cache: true,
                    }).then(function (dataKecamatanDomisili) {

                        $scope.ListKecamatanDomicile = dataKecamatanDomisili.data.d;
                        if ($scope.ListKecamatanDomicile)
                            $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
                    }, function (error) { });
                }


                if ($scope.CIFInvestor.ResidencyNStatus) {
                    var residence = $filter('filter')($scope.ListLookup, { CIFLookupInteger: Number($scope.CIFInvestor.ResidencyNStatus) }, true)[0];
                    $scope.CIFInvestor.ResidencyNStatus = residence;
                }

                if (data.data.d.ResidencyDate)
                    $scope.CIFInvestor.ResidencyDate = new Date(data.data.d.ResidencyDate);


                if (data.data.d.Nationality) {

                    if (data.data.d.Nationality == 102) {
                        $scope.IDLength = 16;
                        $scope.chkSeumurHidup = true;
                        $scope.DisabledSeumurHidup = true;
                        $scope.CIFInvestor.Nationality = 102;
                        $scope.CIFInvestor.NationalityBO = 102;
                        $scope.CIFInvestor.IDCardCountry = 102;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[0];
                        $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
                        $scope.CIFInvestor.IDCardExpireDateBO = new Date(9998, 11, 31);
                        $scope.CIFInvestor.CopyID = true;
                    }
                    else {
                        $scope.IDLength = 8;
                        $scope.chkSeumurHidup = false;
                        $scope.DisabledSeumurHidup = true;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[1];
                        $scope.NationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.Nationality }, true)[0];
                        $scope.IDCardCountrySelected = $filter('filter')($scope.ListCountry, { CIFCountryNID: data.data.d.IDCardCountry }, true)[0];

                        if (data.data.d.IDCardExpireDate)
                            $scope.CIFInvestor.IDCardExpireDate = new Date(data.data.d.IDCardExpireDate);

                        if (data.data.d.IDCardExpireDateBO)
                            $scope.CIFInvestor.IDCardExpireDateBO = new Date(data.data.d.IDCardExpireDateBO);
                    }
                } else {
                    $scope.KewarganegaraanChange();
                }

                if (data.data.d.CopyID)
                    $scope.CopyFromID();

                //-------------------------------------start info bo----------------------------------------------------------------------------------------------
                if (data.data.d.CopyIDBO)
                    $scope.CopyFromIDBO();


                if ($scope.CIFInvestor.QuestionNPWPBO == 0)
                    $scope.CIFInvestor.QuestionNPWPBO = '';

                if ($scope.CIFInvestor.IncomePerAnnumBO == '') {
                    $scope.CIFInvestor.IncomePerAnnumBO = 0;
                }

                if ($scope.CIFInvestor.FundSourceBO) {
                    $scope.selectedFundSourceBO = [];
                    let temp = $scope.CIFInvestor.FundSourceBO.split(',');
                    for (var i = 0; i < temp.length; i++) {
                        $scope.selectedFundSourceBO.push(Number(temp[i]));
                    }
                }

                if ($scope.CIFInvestor.CompanyCityBO)
                    $scope.CompanyCityBOSelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: $scope.CIFInvestor.CompanyCityBO }, true)[0];

                if (data.data.d.BirthDateBO)
                    $scope.CIFInvestor.BirthDateBO = new Date(data.data.d.BirthDateBO);

                if (data.data.d.BOIDCardCity) {
                    $scope.BOIDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.BOIDCardCity }, true)[0];
                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.BOIDCardCity,
                        cache: true,
                    }).then(function (dataKecamatan) {
                        $scope.BOListKecamatan = dataKecamatan.data.d;
                        if ($scope.BOListKecamatan)
                            $scope.BOListKelurahan = $filter('filter')($scope.BOListKecamatan, { Kecamatan: $scope.CIFInvestor.BOIDCardKecamatan }, true);
                    }, function (error) { });
                }

                if (data.data.d.BODomicileCity) {
                    $scope.BODomicileCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.BODomicileCity }, true)[0];

                    $http({
                        method: 'GET',
                        url: '/service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=' + data.data.d.DomicileCity,
                        cache: true,
                    }).then(function (dataKecamatanDomisili) {
                        console.log('domi: ', data);
                        $scope.BOListKecamatanDomicile = data.data.d;
                        if ($scope.BOListKecamatanDomicile)
                            $scope.BOListKelurahanDomicile = $filter('filter')($scope.BOListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.BODomicileKecamatan }, true);
                    }, function (error) { });
                }
                //-------------------------------------end info bo----------------------------------------------------------------------------------------------

            }
        }, function (error) { });
    }

    allPromise.then(function () {

        $scope.GetCIF();

        var SWALtranslate = $scope.SWALtranslate('preparationinfouploadphotocif1');

        Swal.fire({
            title: SWALtranslate.title,
            text: SWALtranslate.message,
            imageAlt: 'Preparation',
            imageHeight: 250,
            animation: false,
            confirmButtonColor: '#FFBC00',
            customClass: {
                confirmButton: 'swal-confirm-button-class',
            },
        });
    });

    $scope.bo = function () {
       

            var SWALtranslate = $scope.SWALtranslate('beneficialowner');

            Swal.fire({
                text: SWALtranslate.message,
                imageAlt: 'BO',
                imageHeight: 250,
                animation: false,
                customClass: {
                    confirmButton: 'swal-confirm-button-class',
                },
            });
        
    }

    $scope.prepareData = function () {

        if ($scope.CIFInvestor.CopyIDBO) {
            $scope.CIFInvestor.BODomicilePostalCode = $scope.CIFInvestor.BOIDCardPostalCode;
            $scope.CIFInvestor.BODomicileAddress = $scope.CIFInvestor.BOIDCardAddress;
            $scope.CIFInvestor.BODomicileRT = $scope.CIFInvestor.BOIDCardRT;
            $scope.CIFInvestor.BODomicileRW = $scope.CIFInvestor.BOIDCardRW;
            $scope.CIFInvestor.BODomicileKelurahan = $scope.CIFInvestor.BOIDCardKelurahan;
            $scope.CIFInvestor.BODomicileKecamatan = $scope.CIFInvestor.BOIDCardKecamatan;
            $scope.CIFInvestor.BODomicileCity = $scope.CIFInvestor.BOIDCardCity;
            $scope.BODomicileCitySelected = $scope.BOIDCardCitySelected;
        }

        if ($scope.selectedFundSourceBO) {
            $scope.CIFInvestor.FundSourceBO = '';
            for (var i = 0; i < $scope.selectedFundSourceBO.length; i++) {
                if ($scope.CIFInvestor.FundSourceBO.length > 0)
                    $scope.CIFInvestor.FundSourceBO += ',';
                $scope.CIFInvestor.FundSourceBO += $scope.selectedFundSourceBO[i];

            }
        }

        if ($scope.CIFInvestor.NationalityBO)
            $scope.CIFInvestor.NationalityBO = Number($scope.CIFInvestor.NationalityBO);

        if ($scope.CIFInvestor.BOIDCardCity)
            $scope.CIFInvestor.BOIDCardCity = Number($scope.CIFInvestor.BOIDCardCity);

        if ($scope.CIFInvestor.BODomicileCity)
            $scope.CIFInvestor.BODomicileCity = Number($scope.CIFInvestor.BODomicileCity);

        if ($scope.CIFInvestor.QuestionNPWPBO == '') {
            $scope.CIFInvestor.QuestionNPWPBO = 0;
        }

        if ($scope.CIFInvestor.IncomePerAnnumBO == '') {
            $scope.CIFInvestor.IncomePerAnnumBO = 0;
        }

        //----------------------------------------------------------------------------------------------
        if ($scope.CIFInvestor.CopyID) {

            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
        }

        if ($scope.CIFInvestor.AccountStatus)
            $scope.CIFInvestor.AccountStatus = Number($scope.CIFInvestor.AccountStatus);

        //if ($scope.CIFInvestor.Sex)
        //    $scope.CIFInvestor.Sex = Number($scope.CIFInvestor.Sex);

        //if ($scope.CIFInvestor.Religion)
        //    $scope.CIFInvestor.Religion = Number($scope.CIFInvestor.Religion);

        //if ($scope.CIFInvestor.MaritalStatus)
        //    $scope.CIFInvestor.MaritalStatus = Number($scope.CIFInvestor.MaritalStatus);

        //if ($scope.CIFInvestor.Education)
        //    $scope.CIFInvestor.Education = Number($scope.CIFInvestor.Education);

        var status1 = $filter('date')(new Date($scope.CIFInvestor.ResidencyDate), 'yyyy-MM-dd');

        if ($scope.CIFInvestor.ResidencyDate) {
            $scope.CIFInvestor.ResidencyDate = status1;
        }

        if ($scope.CIFInvestor.ResidencyNStatus) {
            $scope.CIFInvestor.ResidencyNStatus = $scope.CIFInvestor.ResidencyNStatus.CIFLookupInteger;
        }

        if ($scope.CIFInvestor.Nationality)
            $scope.CIFInvestor.Nationality = Number($scope.CIFInvestor.Nationality);

        if ($scope.CIFInvestor.IDCardCountry)
            $scope.CIFInvestor.IDCardCountry = Number($scope.CIFInvestor.IDCardCountry);

        if ($scope.CIFInvestor.IDCardCity)
            $scope.CIFInvestor.IDCardCity = Number($scope.CIFInvestor.IDCardCity);

        if ($scope.CIFInvestor.DomicileCity)
            $scope.CIFInvestor.DomicileCity = Number($scope.CIFInvestor.DomicileCity);

        if ($scope.CIFInvestor.Education != 1)
            $scope.CIFInvestor.EducationText = '';

        var language;
        if (window.navigator.languages) {

            language = window.navigator.languages[0];
        } else {

            language = window.navigator.userLanguage || window.navigator.language;
        }

        $scope.CIFInvestor.Language = language;

        //var date1 = $filter('date')(new Date($scope.CIFInvestor.BirthDate), 'yyyy-MM-dd');

        if ($scope.CIFInvestor.BirthDate) {
            //var date1 = $filter('date')(new Date($scope.CIFInvestor.BirthDate), 'yyyy-MM-dd');
            //$scope.CIFInvestor.ClientBirthDate1 = $scope.CIFInvestor.BirthDate.toLocaleDateString('en-US');
            //$scope.CIFInvestor.ClientBirthDate2 = $scope.CIFInvestor.BirthDate;
            //$scope.CIFInvestor.ClientBirthDate3 = date1;

            //$scope.CIFInvestor.BirthDate = date1;

            $scope.CIFInvestor.BirthDate = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate1 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate2 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
            $scope.CIFInvestor.ClientBirthDate3 = moment($scope.CIFInvestor.BirthDate).format('YYYY-MM-DD');
        }
    }

    $scope.validation = false;

    $scope.submit = function () {
        $scope.prepareData();

        //setup upload data
        if ($scope.ktpPhoto)
            $scope.CIFInvestor.KTPFile = $scope.ktpPhoto.replace("data:image/jpeg;base64,", "");

        if ($scope.npwpPhoto)
            $scope.CIFInvestor.NPWPFile = $scope.npwpPhoto.replace("data:image/jpeg;base64,", "");

        if ($scope.selfiePhoto)
            $scope.CIFInvestor.SelfieFile = $scope.selfiePhoto.replace("data:image/jpeg;base64,", "");

        if ($scope.othersPhoto)
            $scope.CIFInvestor.OthersFile = $scope.othersPhoto.replace("data:image/jpeg;base64,", "");

        if ($scope.parentPhoto)
            $scope.CIFInvestor.ParentFile = $scope.parentPhoto.replace("data:image/jpeg;base64,", "");

        if ($scope.ttdPhoto)
            $scope.CIFInvestor.TandaTanganFile = $scope.ttdPhoto.replace("data:image/jpeg;base64,", "");

        console.log($scope.CIFInvestor);

        if ($scope.validation) {
            var urlsvc = '/service/client.svc/SaveCIF'; // 1 
            var preconfirmtranslate = "submitCif1"; // 2
            var postData = { cifdata: $scope.CIFInvestor } // 3
            var method = "POST" // 4
            $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                if (issuccess) // 6
                    $window.location.href = "#/cif/data-bank";
            });
        }
        
    }

    $scope.validationinput = function () {
        var errorForm = $scope.myForm1.$error.required
        $scope.validation = $scope.myForm1.$valid;
        var message = [];
        //console.log('error :', errorForm);

        if (errorForm) {
            for (let i = 0; i < errorForm.length; i++) {
                //message += errorForm[i].$name + " , ";
                message.push(errorForm[i].$name);
            }
        }

        if (!$scope.ktpPhoto || !$scope.selfiePhoto || !$scope.ttdPhoto) {
            $scope.validation = false
            message.push("fileUpload");
        }

        //PROSES VALIDATION
        if ($scope.validation == false) {
            console.log("error : " + message);

            var SWALtranslate = $scope.SWALtranslate('validationinput');
            Swal.fire({
                title: SWALtranslate.title,
                text: SWALtranslate.message,
                imageUrl: 'img/collection/wrong.png',
                imageAlt: 'Preparation',
                imageHeight: 250,
                animation: false,
                customClass: {
                    confirmButton: 'swal-confirm-button-class',
                },
            });

            return;
        }
    }
}]);

